import { createContext } from 'react';

export const SlideContext = createContext();
